// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cdlJ","title":"InfoRow_title__37VZp"};